import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import { authorize } from 'src/utils/auth';
import { DEVELOPER_LEVEL_ACCESS } from './access';

const HighGuard = ({ children }) => {
    const { user } = useAuth();
    const history = useHistory();

    if (!localStorage.getItem('token')) {
        history.push('/login');
    }

    useEffect(() => {
        if (!authorize(user?.accessLevel, DEVELOPER_LEVEL_ACCESS)) {
            history.push('/management/leads');
        }

        //eslint-disable-next-line
    }, [user]);

    return <>{children}</>;
};

HighGuard.propTypes = {
    children: PropTypes.node,
};

export default HighGuard;
